<template>
  <Modal v-model="modalValue" :title="isEdit ? `编辑` : '新增'" width="800" @on-cancel="modalCancel">
    <Row style="max-height: 600px; overflow-y: auto">
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <FormItem label="姓名" prop="name">
            <Input placeholder="请输入姓名" v-model="form.name"></Input>
          </FormItem>
          <FormItem label="性别" prop="gender">
            <RadioGroup v-model="form.gender">
              <Radio v-for="(item, index) in mapData.genderList" :key="index" :label="item.value">
                {{ item.text }}
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="手机" prop="mobile">
            <Input placeholder="请输入手机" v-model="form.mobile"></Input>
          </FormItem>
          <FormItem label="微信" prop="wechat">
            <Input placeholder="请输入微信" v-model="form.wechat"></Input>
          </FormItem>
          <FormItem label="政治面貌" prop="political_outlook">
            <Select v-model="form.political_outlook" placeholder="请选择政治面貌">
              <Option
                v-for="(item, index) in mapData.politicalOutlook"
                :value="item.value"
                :label="item.text"
                :key="index"
              ></Option>
            </Select>
          </FormItem>
          <FormItem label="所在地" prop="address">
            <Cascader @on-change="addressChange" :data="addressList" v-model="form.address_code"></Cascader>
          </FormItem>
          <FormItem label="学历" prop="education">
            <Input placeholder="请输入学历" v-model="form.education"></Input>
          </FormItem>
          <FormItem label="工作单位/学校" prop="unit">
            <Input placeholder="请输入工作单位/学校" v-model="form.unit"></Input>
          </FormItem>
          <FormItem label="职位" prop="position">
            <Input placeholder="请输入职位" v-model="form.position"></Input>
          </FormItem>
          <FormItem label="舞蹈种类" prop="dance_category">
            <Select v-model="form.dance_category" placeholder="请选择舞蹈种类">
              <Option
                v-for="(item, index) in mapData.danceList"
                :value="item.value"
                :label="item.text"
                :key="index"
              ></Option>
            </Select>
          </FormItem>
          <FormItem label="申请会员类型" prop="member_type">
            <Select v-model="form.member_type" placeholder="请选择申请会员类型">
              <Option
                v-for="(item, index) in mapData.memberList"
                :value="item.value"
                :label="item.text"
                :key="index"
              ></Option>
            </Select>
          </FormItem>
          <FormItem label="个人简历" prop="vita">
            <Input type="textarea" placeholder="请输入个人简历" v-model="form.vita"></Input>
          </FormItem>
          <FormItem label="个人照片" prop="avtar">
            <uploadFileOne @on-change="imageChange($event, 1)" :path="form.avtar" :url="form.avtar_url"></uploadFileOne>
          </FormItem>
          <FormItem label="个人证明材料上传" prop="prove">
            <div v-if="form.prove.length > 0" class="look-img-wrap">
              <div class="look-img" v-for="(item, index) in form.prove_url" :key="index">
                <img :src="item" style="width: 100%" />
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="lookFile('prove', item)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="deleteFile('prove', index)"></Icon>
                </div>
              </div>
            </div>
            <Upload
              v-if="form.prove.length < 5"
              :action="import_url"
              :headers="headers"
              :on-error="uploadErr"
              :on-success="uploadSuccess"
              name="image"
              :show-upload-list="false"
            >
              <div class="upload-btn">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或者拖拽文件上传</p>
              </div>
            </Upload>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button type="primary" :loading="btnLoading" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import * as apiMember from '@/api/member'
  import * as mapData from '../map.js'
  import uploadFileOne from '@/components/upload-custom/upload-file-one.vue'
  export default {
    name: 'add-card',
    components: {
      uploadFileOne,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        btnLoading: false,
        mapData, // 映射数据
        form: {
          name: '',
          gender: '',
          mobile: '',
          wechat: '',
          political_outlook: '',
          address: [],
          address_code: [],
          education: '',
          unit: '',
          position: '',
          dance_category: '',
          member_type: '',
          vita: '',
          avtar: '',
          avtar_url: '',
          prove: [],
          prove_url: [],
        },
        rules: {
          name: [{ required: true, message: '姓名不能为空', triggier: 'blur' }],
          gender: [{ required: true, type: 'number', message: '性别不能为空', triggier: 'change' }],
          mobile: [{ required: true, message: '手机号不能为空', triggier: 'blur' }],
          wechat: [{ required: true, message: '微信号不能为空', triggier: 'blur' }],
          address_code: [{ required: true, type: 'array', message: '所在地不能为空', triggier: 'change' }],
          unit: [{ required: true, message: '工作单位/学校不能为空', triggier: 'blur' }],
          member_type: [{ required: true, type: 'number', message: '申请会员类型不能为空', triggier: 'change' }],
          vita: [{ required: true, message: '个人简历不能为空', triggier: 'blur' }],
          avtar: [{ required: true, message: '个人照片不能为空', triggier: 'blur' }],
          political_outlook: [{ required: true, type: 'number', message: '政治面貌不能为空', trigger: 'blur' }],
        },
        addressList: [],
      }
    },
    methods: {
      // 获取详情
      getDetail() {
        apiMember.apiPersonMemberDetail(this.id).then(res => {
          const { data } = res
          this.form.name = data.name
          this.form.gender = data.gender
          this.form.mobile = data.mobile
          this.form.wechat = data.wechat
          this.form.political_outlook = data.political_outlook
          this.form.address = data.address
          this.form.address_code = data.address_code
          this.form.unit = data.unit
          this.form.education = data.education
          this.form.position = data.position
          this.form.dance_category = data.dance_category
          this.form.member_type = data.member_type
          this.form.vita = data.vita
          this.form.avtar = data.avtar
          this.form.avtar_url = data.avtar_url
          this.form.prove = data.prove
          this.form.prove_url = data.prove_url
        })
      },
      // 地址选择确定
      addressChange(value, selectedData) {
        this.form.address = selectedData.map(item => item.label)
      },
      // 图片上传
      imageChange(e, index) {
        if (index == 1) {
          this.form.avtar = e.path
          this.form.avtar_url = e.url
        } 
      },
      // 上传成功
      uploadSuccess(res, file) {
        if (res.code == 0) {
          this.$Message.success('上传成功')
          this.form.prove.push(res.data.path)
          this.form.prove_url.push(res.data.url)
        } else {
          this.$Modal.error({
            title: '系统提示',
            content: res.message,
          })
        }
      },
      uploadErr() {
        if (file.status_code == 401) {
          localStorage.removeItem('token')
          return this.$router.push({
            name: 'login',
          })
        }
        this.$Modal.error({
          title: '提示',
          content: '文件上传失败，请重试',
        })
      },

      lookFile(type, item) {
        if (type == 'information') {
          window.open(item)
        }
      },
      deleteFile(type, index) {
        if (type == 'information') {
          this.form.prove.splice(index, 1)
          this.form.prove_url.splice(index, 1)
        }
      },
      // 提交
      modalConfirm() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.btnLoading = true
            if (this.isEdit) {
              apiMember.apiPersonMemberUpdate(this.id, this.form).then(res => {
                this.$Message.success('编辑成功')
                this.$emit('on-success')
                this.modalCancel()
              }).finally(() => this.btnLoading = false)
            }
          }
        })
      },
      modalCancel() {
        this.$refs['addForm'].resetFields()
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
      // 获取地址
      getRegion() {
        apiMember.apiRegionList().then(res => {
          this.addressList = res.data[0].children
        })
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
      import_url() {
        return process.env.VUE_APP_API_URL + '/admin/upload/image'
      },
      headers() {
        return {
          authorization: localStorage.getItem('token'),
        }
      },
    },
    watch: {
      value(val) {
        if (val && this.isEdit) {
          this.getRegion()
          this.getDetail()
        }
      },
    },
  }
</script>

<style scoped lang="less">
  .upload-btn {
    cursor: pointer;
    padding: 20px 20px;
    border-radius: 5px;
    border: 1px dashed #dcdee2;
    text-align: center;
  }
  .upload-btn:hover {
    transition: all 0.2s;
    box-shadow: 2px 2px 24px rgba(0, 0, 0, 0.1);
  }
  .look-img-wrap {
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .look-img {
    margin: 5px;
    display: flex;
    align-items: center;
    width: 110px;
    height: 110px;
    padding: 10px;
    border: 1px dashed rgba(197, 197, 197, 1);
    text-align: center;
    justify-content: space-evenly;
    position: relative;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
  }

  .look-img:hover .demo-upload-list-cover {
    display: block;
  }
  .demo-upload-list-cover i {
    line-height: 98px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
